import { HistoricalDataBody } from '@arpav/components/ArpavTheme';
import HistoricalDataSchema from '@arpav/components/ArpavTheme/Blocks/HistoricalData/schema';
import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import { BlockDataForm } from '@plone/volto/components';

const Edit = props => {
  const { block, data, selected, onChangeBlock, intl } = props;

  const schema = HistoricalDataSchema({ ...props, intl, data });
  return (
    <div className="public-ui">
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema?.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
        />
      </SidebarPortal>
      <HistoricalDataBody {...props} data={data} isEditMode={true} />
    </div>
  );
};

export default withBlockExtensions(Edit);
